<div class="ks-container">
  <header class="ks-page-header ks-rise-1">
    <div>
      <h1 class="ks-page-title">Prerellenados</h1>
      <p class="ks-page-subtitle">
        Valores sugeridos para una plantilla, listos para que la app los proponga. Aceleran el alta
        sin guardar ninguna credencial.
      </p>
    </div>

    <button type="button" class="ks-btn ks-btn--primary" (click)="create()">
      <i class="bi bi-plus-lg" aria-hidden="true"></i>
      Nuevo prerellenado
    </button>
  </header>

  <div class="ks-filter-bar ks-rise-2">
    <div class="ks-filter-bar__controls">
      <label class="ks-visually-hidden" for="ks-prefills-search">Buscar prerellenado</label>
      <input
        id="ks-prefills-search"
        type="search"
        class="ks-field"
        placeholder="Buscar por nombre o plantilla"
        [value]="search()"
        (input)="onSearchChange($any($event.target).value)" />

      <!--
        ng-select, no <select>: todos los desplegables de la consola deben
        permitir BUSCAR. El id del input interno lo pone `labelForId`, asi que el
        `<label for>` de arriba sigue apuntando al elemento que recibe el foco.
      -->
      <div class="ks-prefills__status-filter">
        <label class="ks-visually-hidden" for="ks-prefills-status">Filtrar por estado</label>
        <ng-select
          labelForId="ks-prefills-status"
          [items]="statusOptions"
          bindLabel="label"
          bindValue="value"
          [ngModel]="statusFilter()"
          (change)="onStatusFilterChange($event)"
          placeholder="Todos los estados"
          notFoundText="Sin resultados"
          clearAllText="Quitar selección"
          loadingText="Cargando…"
          typeToSearchText="Escribe para buscar"
          [searchable]="true"
          [clearable]="true" />
      </div>
    </div>

    <div class="ks-filter-bar__actions">
      <span class="ks-count" aria-live="polite">
        {{ visiblePrefills().length }} de {{ prefills().length }} · {{ activeCount() }} activos
      </span>
    </div>
  </div>

  <!-- Orden obligatorio: carga -> error -> vacio -> tarjetas. El estado vacio
       solo puede aparecer cuando ya se sabe con certeza que no hay datos. -->
  @if (!loaded() || loading()) {
    <div class="ks-grid ks-grid-3 ks-rise-3">
      @for (item of skeletons; track item) {
        <div class="ks-card">
          <div class="ks-skeleton-stack">
            <app-skeleton shape="block" height="120px" label="Cargando prerellenados" />
            <app-skeleton width="70%" height="16px" />
            <app-skeleton width="45%" />
          </div>
        </div>
      }
    </div>
  } @else if (error()) {
    <section class="ks-panel ks-rise-3">
      <app-empty-state
        icon="wifi-off"
        title="No se pudieron cargar los prerellenados"
        [message]="error()!">
        <button type="button" class="ks-btn ks-btn--glass ks-btn--sm" (click)="load()">
          <i class="bi bi-arrow-clockwise" aria-hidden="true"></i>
          Reintentar
        </button>
      </app-empty-state>
    </section>
  } @else if (visiblePrefills().length === 0) {
    <section class="ks-panel ks-rise-3">
      <app-empty-state
        icon="bookmarks"
        title="Sin prerellenados"
        message="No hay prerellenados que coincidan con el filtro. Crea uno a partir de una plantilla activa.">
        <button type="button" class="ks-btn ks-btn--glass ks-btn--sm" (click)="create()">
          <i class="bi bi-plus-lg" aria-hidden="true"></i>
          Nuevo prerellenado
        </button>
      </app-empty-state>
    </section>
  } @else {
    <ul class="ks-grid ks-grid-3 ks-rise-3 ks-cards">
      @for (prefill of visiblePrefills(); track prefill.prefillId) {
        <li class="ks-card ks-card--interactive ks-pcard" [class.ks-pcard--off]="!prefill.status">
          <span class="ks-pcard__thumb" aria-hidden="true">
            @if (prefill.image) {
              <img [src]="prefill.image.urlFile" alt="" loading="lazy" />
            } @else {
              <i class="bi bi-bookmark"></i>
            }
          </span>

          <div class="ks-pcard__body">
            <h2 class="ks-pcard__name">
              <a class="ks-pcard__link" [routerLink]="['/dashboard/catalogues/prefills', prefill.prefillId]">
                {{ prefill.name }}
              </a>
            </h2>

            <p class="ks-pcard__template">
              <i class="bi bi-file-earmark-text" aria-hidden="true"></i>
              {{ templateName(prefill) }}
            </p>

            <div class="ks-pcard__meta">
              <span class="ks-badge ks-badge--info">
                <i class="bi bi-input-cursor-text" aria-hidden="true"></i>
                {{ prefill.values.length }} valores
              </span>

              @if (prefill.status) {
                <span class="ks-badge ks-badge--success">Activo</span>
              } @else {
                <span class="ks-badge ks-badge--muted">Inactivo</span>
              }
            </div>
          </div>

          <div class="ks-pcard__actions">
            <button
              type="button"
              class="ks-icon-btn"
              [attr.aria-label]="'Editar el prerellenado ' + prefill.name"
              (click)="edit(prefill, $event)">
              <i class="bi bi-pencil" aria-hidden="true"></i>
            </button>

            @if (prefill.status) {
              <button
                type="button"
                class="ks-icon-btn ks-icon-btn--danger"
                [attr.aria-label]="'Desactivar el prerellenado ' + prefill.name"
                (click)="deactivate(prefill, $event)">
                <i class="bi bi-slash-circle" aria-hidden="true"></i>
              </button>
            }
          </div>
        </li>
      }
    </ul>
  }
</div>
